import React, { Component } from 'react'
import { DataGrid, GridColumn, LinkButton, Panel } from 'rc-easyui';
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
const axios = require("axios");


export default class ViewProject extends Component {
  constructor(props) {
    super(props)

    this.state = {
      projectDetail: [],
      pageOptions: {},
      form: {
        total: '',
        pageSize: '',
        pageNumber: ''

      },
      selected: {

      },
      isLoading: false,
      pageOptions: {
        pageOptions: {
          layout: [
            "list",
            "sep",
            "first",
            "prev",
            "next",
            "last",
            "sep",
            "refresh",
            "sep",
            "manual",
            "info",
          ],
        },
      },
    }
  }
  componentDidMount = async () => {


    this.setState({


      pageOptions: {
        loading: true,
        pageOptions: {
          pageNumber: 1,
          pageSize: 10,
          total: 1000,
          pagePosition: 'bottom',
          pageList: [10, 20, 30, 40, 50, 60, 70, 80],
          layout: [
            'list',
            'sep',
            'first',
            'prev',
            'next',
            'last',
            'sep',
            'refresh',
            'sep',
            'manual',
            'info',
          ],
        },
      },

    },
      () => {
        this.getPageData()


      })
  }

  async getPageData() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/fetchallprojectInfo`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          //console.log("response data",response);
          let data = response.data.object;

          if (response.status === 200 && data.length > 0) {
            //console.log(data);
            this.setState({
              projectDetail: data,
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getPageData();
      }
    }
  }
  onSelectionChange(selectedRow) {

    this.setState({
      selected: selectedRow,
    });
  }
  onPageChange(event) {
    // //delete event["refresh"];
    // delete event["filterRules"];
    // //console.log(event);
    // this.setState(
    //   {
    //     pageOptions: {
    //       pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
    //       loading: true,
    //     },
    //   },
    //   function () {
    //     this.getPageData();
    //   }
    // );
  }
  render() {
    const { projectDetail } = this.state;
    return (
      <div>
        <Panel
          title='Project List'
          bodyStyle={{ padding: 0 }}
          style={{ height: 430 }}
        >
          <DataGrid
            data={projectDetail}
            style={{ height: 400 }}
            {...this.state.pageOptions}
            pagination
            {...this.props.selectedRow}
            onPageChange={this.onPageChange}
          >
            <GridColumn
              field='rn'
              align='center'
              width='30px'
              cellCss='datagrid-td-rownumber'
              render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
            />
            <GridColumn field="projectName" title="Project Name" ></GridColumn>
            <GridColumn field="projectManagerName" title="Project Manager Name" ></GridColumn>
            <GridColumn field="act" title="Actions" align="center" width={110}
              render={({ row }) => (
                <div>
                  <LinkButton
                    onClick={() => this.props.OnEditClick(row)}
                    style={{ width: 50 }}
                  >Edit</LinkButton>
                </div>
              )}
            />



          </DataGrid>
        </Panel>
      </div>
    )
  }
}
